import { render, staticRenderFns } from "./ModalChangeDefault.vue?vue&type=template&id=3d514c69&"
import script from "./ModalChangeDefault.vue?vue&type=script&lang=js&"
export * from "./ModalChangeDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ModalChangeDefault.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d514c69')) {
      api.createRecord('3d514c69', component.options)
    } else {
      api.reload('3d514c69', component.options)
    }
    module.hot.accept("./ModalChangeDefault.vue?vue&type=template&id=3d514c69&", function () {
      api.rerender('3d514c69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/globals/ModalChangeDefault.vue"
export default component.exports